<template>
  <div class="side-bar col-md-10 offset-md-1 col-lg-3 offset-lg-0 order-3" v-if="utilityTab === 'notes'">
    <div class="pt-lg-3">
      <div v-if="!isAuthenticated" class="text-center">
        <p class="lead">{{ 'Want to make notes?' | translate }}</p>
        <router-link :to="{ name: 'login', params: { course: $route.params.course } }">
          {{ 'Log in now' | translate }}
        </router-link>
      </div>
      <div v-else class="">
        <Notes v-if="lecture" :lecture="lecture"></Notes>
      </div>
    </div>
  </div>
</template>

<script>
import Notes from './Notes'
import _ from 'lodash'

export default {
  components: {
    Notes,
  },
  computed: {
    utilityTab() {
      return this.$store.state.lectureUtilityTab
    },
    isAuthenticated() {
      return this.$store.state.user.name ? true : false
    },
    lecture() {
      return _.flatten(this.$store.state.course.sections.map((section) => section.lectures)).find(
        (lecture) => lecture.id == this.$route.params.lecture,
      )
    },
  },
}
</script>
